import React from 'react';

export const useScript = (code: string, disabled?: boolean): void => {
  React.useEffect(() => {
    if (disabled) return;
    const script = document.createElement('script');
    script.text = code;
    document.body.appendChild(script);
    return (): void => {
      document.body.removeChild(script);
    };
  }, [code, disabled]);
};
